export default {
  'Teklif Formu': 'Quotation Form',
  'Kayıtlı Teklifler': 'Saved Quotations',
  'Kullanıcı Adı': 'Username',
  'Şifre': 'Password',
  'Giriş Yap': 'Login',
  'Çıkış Yap': 'Logout',
  'KDV Oranı': 'VAT Rate',
  'Teklif Durumu': 'Quotation Status',
  'Kaydet': 'Save',
  'PDF Önizleme': 'PDF Preview',
  'PDF\'ye Aktar': 'Export to PDF',
  'E-posta ile Gönder': 'Send by Email',
  'Alıcı': 'Recipient',
  'Tarih': 'Date',
  'Genel Toplam': 'Grand Total',
  'Not': 'Note',
  'KDV': 'VAT',
  'Alt Toplam': 'Subtotal',
  'Açıklama': 'Description',
  'Ürün Adı': 'Product Name',
  'SUT Kodu': 'SUT Code',
  'Birim Alış Fiyatı': 'Unit Price',
  'Sipariş Adedi': 'Order Qty',
  'Promosyon Ürün': 'Promo Product',
  'Toplam Adet': 'Total Qty',
  'Sipariş Tutarı': 'Order Total',
  'Durum': 'Status',
  'Kabul Edildi': 'Accepted',
  'Reddedildi': 'Rejected',
  'Gönderildi': 'Sent',
  'Taslak': 'Draft',
  'Yurtiçi': 'Domestic',
  'Yurtdışı': 'International',
  'Sipariş Oluştur': 'Create Order',
  'Ürün Sıralaması': 'Product Sorting',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Products are sorted by popularity and importance level',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Cardiology and vascular surgery products are shown as priority',
  'Ürün adı, açıklama veya barkod ile ara...': 'Search by product name, description or barcode...',
  'Tüm Kategoriler': 'All Categories',
  'Kutu görünüm': 'Grid view',
  'Liste görünüm': 'List view',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'No products found matching your criteria',
  'Ürün Adı Yok': 'No Product Name',
  'Kategori Yok': 'No Category',
  'Açıklama yok': 'No description',
  'Firma Bilgilerini Doldurun': 'Fill Company Information',
  'Sepete Ekle': 'Add to Cart',
  'Firma Bilgileri': 'Company Information',
  'Ülke Seçimi': 'Country Selection',
  'Türkiye': 'Turkey',
  'Almanya': 'Germany',
  'ABD': 'USA',
  'Firma Ünvanı': 'Company Name',
  'Vergi Dairesi': 'Tax Office',
  'Vergi Numarası': 'Tax Number',
  'Adres': 'Address',
  'Şehir': 'City',
  'Şehir Seçimi': 'City Selection',
  'Şehir adı ara...': 'Search city name...',
  'Aradığınız şehir bulunamadı': 'City not found',
  'Bu ülke için şehir verisi bulunamadı': 'No city data available for this country',
  'şehir bulundu': '{{count}} cities found',
  'Yetkili': 'Authorized Person',
  'Telefon': 'Phone',
  'Email': 'Email',
  'Bilgileri İlet': 'Submit Information',
  'Lütfen eksik alanları doldurun': 'Please fill in the missing fields',
  'Firma kaydedilemedi': 'Company could not be saved',
  'Firma bilgileri başarıyla iletildi': 'Company information submitted successfully',
  'Firma Ünvanı:': 'Company Name:',
  'Yetkili Kişi:': 'Authorized Person:',
  'Sepetiniz': 'Your Cart',
  'Sepetiniz boş': 'Your cart is empty',
  'adet': 'pcs',
  'Düzenle': 'Edit',
  'Kaldır': 'Remove',
  'Siparişi Tamamla': 'Complete Order',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Please submit your company information completely first',
  'Sipariş başarıyla kaydedildi': 'Order saved successfully',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Welcome message and access link sent to your email',
  'Link 3 gün geçerlidir': 'Link is valid for 3 days',
  'Sipariş kaydedilemedi': 'Order could not be saved',
  'Firma Bilgileri Gerekli': 'Company Information Required',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Fill company information first to add to cart',
  'Önce Bilgileri Doldurun': 'Fill Information First',
  'Uyarı': 'Warning',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'You need to fill company information first to add to cart',
  'SUT Kütüphanesi Tanımı': 'SUT Library Definition',
  'SUT Kodu:': 'SUT Code:',
  'Standart': 'Standard',
  'Açıklama (isteğe bağlı)': 'Description (optional)',
  'Partner Ol': 'Become Partner',
  'Partner başvuru popup açılacak': 'Partner application popup will open',
  'Dil': 'Language',
  'globalPartnersTitle': 'Collaborating with 30,000 Partners Worldwide',
  'globalPartnersDesc': 'Our extensive global network of 30,000 partners drives shared innovation, knowledge exchange, and mutual success. By working together, we continuously expand the frontiers of patient care.',
  'bayiBasvuru': 'INVAMED Partner Application Form',
  'bayiBasvuruDesc': 'Fill out the form below to join the INVAMED partner network. We will get back to you after reviewing your application.',
  'applyFields': {
    'firma': 'Company Title',
    'vergiNo': 'Tax Office / Tax Number',
    'yetkili': 'Authorized Person Name Surname',
    'telefon': 'Phone',
    'email': 'E-mail',
    'adres': 'Address',
    'sektor': 'Activity Area / Sector',
    'sicil': 'Trade Registry Number',
    'web': 'Website'
  },
  'Giriş Yap': 'Login',
  'E-posta': 'Email',
  'E-Posta': 'Email',
  'Şifre': 'Password',
  'Şifremi Unuttum': 'Forgot Password',
  'Demo Giriş': 'Demo Login',
  'Üye Ol': 'Sign Up',
  'Üye Değil Misiniz?': 'Not a Member?',
  'Şimdi Üye Ol': 'Sign Up Now',
  'Yardım': 'Help',
  'dil': 'Language',
  'Ülke Seçiniz': 'Select Country',
  'Firma / Sağlık Profesyoneli': 'Company / Healthcare Professional',
  'Şehir Seçiniz': 'Select City',
  'Yetkili Kişi': 'Authorized Person',
  'UDI Kodu': 'UDI Code',
  'Teklif başarıyla kaydedildi!': 'Quotation saved successfully!',
  'Aynı teklif zaten kayıtlı!': 'Same quotation already saved!',
  'Kullanıcı adı veya şifre hatalı!': 'Username or password incorrect!',
  'Teklif No': 'Quotation No',
  'Teklifler': 'Quotations',
  'Yedeklenecek teklif yok!': 'No quotations to backup!',
  'Yedek dosyası indirildi.': 'Backup file downloaded.',
  'Yedek başarıyla yüklendi.': 'Backup loaded successfully.',
  'Geçersiz veya bozuk dosya!': 'Invalid or corrupted file!',
  'Yedekle (JSON)': 'Backup (JSON)',
  'Geri Yükle': 'Restore',
  'Kayıtlı teklif yok.': 'No saved quotations.',
  'E-posta Durumu': 'Email Status',
  'İşlemler': 'Actions',
  'E-posta ile gönderildi': 'Sent by email',
  'E-posta gönderilmedi': 'Email not sent',
  'Görüntüle': 'View',
  'Sil': 'Delete',
  'Gönderildi': 'Sent',
  'Gönderilmedi': 'Not sent',
  'Teklif ID bulunamadı! Lütfen tekrar deneyin.': 'Quotation ID not found! Please try again.',
  'Lütfen partner seçiniz.': 'Please select a partner.',
  'Lütfen teslimat tarihi belirtiniz.': 'Please specify delivery date.',
  'Proforma başarıyla oluşturuldu!': 'Proforma created successfully!',
  'Proforma oluşturuldu ancak ürün eklenemedi. Detaylar için konsolu kontrol edin.': 'Proforma created but products could not be added. Check console for details.',
  'Link başarıyla silindi': 'Link deleted successfully',
  'Link kopyalandı!': 'Link copied!',
  'Ödeme durumu başarıyla güncellendi!': 'Payment status updated successfully!',
  'dosyası okunamadı!': 'file could not be read!',
  'Tüm dosyalar için SUT kodu ve fiyat kolonlarını seçmelisiniz!': 'You must select SUT code and price columns for all files!',
  'Yüklenecek geçerli satır bulunamadı! Lütfen dosya(lar)da SUT kodu ve fiyatı dolu satır olduğundan emin olun.': 'No valid row to upload found! Please make sure there are rows with SUT code and price filled in the file(s).',
  'Yükleme sırasında hata oluştu!': 'Error occurred during upload!',
  'Otomatik etiket ekleme başarısız!': 'Automatic tag addition failed!',
  'Etiketler başarıyla güncellendi!': 'Tags updated successfully!',
  'Etiketler güncellenirken hata oluştu!': 'Error occurred while updating tags!',
  'Resim başarıyla yüklendi!': 'Image uploaded successfully!',
  'Resim yüklendi ama ürün güncellenemedi!': 'Image uploaded but product could not be updated!',
  'Resim yüklenirken hata oluştu!': 'Error occurred while uploading image!',
  'Ürün başarıyla güncellendi!': 'Product updated successfully!',
  'Ürün güncellenirken hata oluştu!': 'Error occurred while updating product!',
  'Hata:': 'Error:',
  'Güncelleme hatası:': 'Update error:',
  'Alanlar yüklendi:': 'Fields loaded:',
  'alan': 'field',
  'Misafir Olarak Sipariş Verin': 'Order as Guest',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Quickly select your products and create your order without logging in',
  'Misafir Kullanıcı': 'Guest User',
  'Hızlı Sipariş': 'Quick Order',
  'Giriş yapmadan sipariş oluşturun': 'Create order without logging in',
  'Anında Erişim': 'Instant Access',
  'Tüm ürünlere anında erişim': 'Instant access to all products',
  'Güvenli İşlem': 'Secure Transaction',
  'SSL korumalı güvenli sipariş': 'SSL protected secure order',
  'Misafir Olarak Sipariş Oluştur': 'Create Order as Guest',
  'İpucu:': 'Tip:',
  'Daha fazla özellik için üye olun': 'Sign up for more features',
  'Ücretsiz': 'Free',
  'Hızlı': 'Fast',
  'Güvenli': 'Secure',
  'Giriş yapılıyor...': 'Logging in...',
  'bayilikSozlesme': 'I have read and accept the INVAMED partnership terms and conditions.',
  'geri': 'Back',
  'basvuruGonder': 'Submit Application',
  'ileri': 'Next',
  'sozlesmeGonderildi': 'Contract Sent to Your Email!',
  'sozlesmeDesc': 'Please upload the INVAMED Partnership Contract and required documents sent to your email address below.',
  'tamamla': 'Complete Application',
  'basvuruAlindi': 'Your Application Has Been Received!',
  'basvuruAlindiDesc': 'The INVAMED team will review your application and contact you as soon as possible.',
  'Başvuru Durumu': 'Application Status',
  'Başvurunuz onay sürecindedir': 'Your application is under review',
  'sifreSifirla': 'Reset Password',
  'sifreSifirlaDesc': 'Enter your registered email address and we will send you instructions to reset your password.',
  'gonder': 'Send',
  'talimatGonderildi': 'Instructions Sent',
  'sentDesc': 'Password reset instructions have been sent to <b>{email}</b>. Please check your email.',
  'helpTitle': 'How can I log in?',
  'helpList': [
    'To log in to the INVAMED dealer panel, enter your registered email address and password.',
    'To log in with demo user:',
    'If you forgot your password, use the "Forgot Password" link to request a reset.',
    'If you have login problems, make sure your email and password are correct. If the problem persists, contact our support team.'
  ],
  'partnerlikSozlesmeTitle': 'INVAMED Partnership Agreement and Terms',
  'partnerlikSozlesmeText': `1. GENERAL PROVISIONS

This agreement is concluded between INVAMED (hereinafter referred to as "Company") and the partner candidate (hereinafter referred to as "Partner") for the purpose of cooperation in the sale of medical devices and equipment.

2. PARTNERSHIP CONDITIONS

2.1. The Partner must have legal authority for the sale of medical devices.
2.2. The Partner must be an organization operating in the healthcare sector.
2.3. The Partner must have the necessary licenses and certificates.
2.4. The Partner must be financially reliable.

3. OBLIGATIONS OF THE PARTIES

Company Obligations:
3.1. Provide quality products and services
3.2. Provide technical support
3.3. Provide training and information
3.4. Be transparent about pricing

Partner Obligations:
3.1. Store products in appropriate conditions
3.2. Provide quality customer service
3.3. Comply with legal regulations
3.4. Protect the company brand

4. PRICING AND PAYMENT

4.1. Prices are determined by the Company
4.2. The Partner is obliged to maintain the determined prices
4.3. Payment terms are determined separately
4.4. Commission rates may vary according to performance

5. CONFIDENTIALITY AND SECURITY

5.1. The parties are obliged to protect each other's confidential information
5.2. Customer information must be kept confidential
5.3. Data security standards must be complied with

6. DURATION AND TERMINATION OF THE AGREEMENT

6.1. This agreement is valid for 1 year
6.2. May be extended by mutual agreement
6.3. May be terminated with 30 days notice
6.4. May be terminated immediately in case of serious violation

7. DISPUTE RESOLUTION

7.1. Disputes are primarily attempted to be resolved through negotiation
7.2. Courts of the Republic of Turkey are authorized for unresolved cases

8. EFFECTIVENESS

This agreement has been read, understood and accepted by the parties.`,
  'partnerlikSozlesmeOnay': 'I have read, understood and accept the above INVAMED Partnership Agreement and Terms. I declare that I accept all articles of this agreement and will fulfill my obligations.',
  'sozlesmeyiGoruntule': 'View Agreement',
  'sozlesmeyiKapat': 'Close',
  'Ürün': 'Product',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Select products from the list to add to cart',
  'Etiketler': 'Tags',
  'Öncelikli': 'Priority',
  'Connect Free!': 'Connect Free!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Discover our most preferred products',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 products displayed (Total: 8000+)',
  'Tüm Ürünleri Gör →': 'See All Products →',
  'Detaylar': 'Details',
  'Sipariş Ver': 'Order Now',
  'Giriş Yap': 'Login',
  'Hesabınıza giriş yapın': 'Login to your account',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.',
  'Ürün Kataloğumuz': 'Our Product Catalog',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'We serve with 8000+ product variety',
  '1,3B': '1.3K',
  'Partner': 'Partner',
  '8,4M': '8.4M',
  'Toplam Üretim': 'Total Production',
  '23': '23',
  'Branş': 'Branch',
  '27,5B': '27.5K',
  'Toplam Sipariş': 'Total Orders',
  'Connect Now': 'Connect Now',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Sign up for free to access all information in one place.',
  'Ürün Detayları': 'Product Details',
  'Kapat': 'Close',
  'Yükleniyor...': 'Loading...',
  'Hata': 'Error',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} products displayed (Total: 8000+)',
  'Şehir Seçimi': 'City Selection',
  'Firma / Sağlık Profesyoneli': 'Company / Healthcare Professional',
  'Yetkili Kişi': 'Authorized Person',
  'Telefon': 'Phone',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Basic Information',
  'Ek Bilgiler': 'Additional Information',
  'Faaliyet Alanı / Sektör': 'Activity Area / Sector',
  'Ülke Seçimi': 'Country Selection',
  'Ülke adı veya kodu ara...': 'Search country name or code...',
  'region.Avrupa': 'Europe',
  'region.Amerika': 'America',
  'region.Asya': 'Asia',
  'region.Afrika': 'Africa',
  'region.Okyanusya': 'Oceania',
  'region.Diğer': 'Other',
  // Country translations
  'country.TR': 'Turkey',
  'country.AL': 'Albania',
  'country.DE': 'Germany',
  'country.AD': 'Andorra',
  'country.AT': 'Austria',
  'country.BY': 'Belarus',
  'country.BE': 'Belgium',
  'country.BA': 'Bosnia and Herzegovina',
  'country.BG': 'Bulgaria',
  'country.CZ': 'Czech Republic',
  'country.DK': 'Denmark',
  'country.EE': 'Estonia',
  'country.FO': 'Faroe Islands',
  'country.FI': 'Finland',
  'country.FR': 'France',
  'country.GI': 'Gibraltar',
  'country.GR': 'Greece',
  'country.GG': 'Guernsey',
  'country.HR': 'Croatia',
  'country.NL': 'Netherlands',
  'country.IE': 'Ireland',
  'country.ES': 'Spain',
  'country.SE': 'Sweden',
  'country.CH': 'Switzerland',
  'country.IT': 'Italy',
  'country.IS': 'Iceland',
  'country.JE': 'Jersey',
  'country.ME': 'Montenegro',
  'country.LV': 'Latvia',
  'country.LI': 'Liechtenstein',
  'country.LT': 'Lithuania',
  'country.LU': 'Luxembourg',
  'country.HU': 'Hungary',
  'country.MT': 'Malta',
  'country.IM': 'Isle of Man',
  'country.MD': 'Moldova',
  'country.MC': 'Monaco',
  'country.MK': 'North Macedonia',
  'country.NO': 'Norway',
  'country.PL': 'Poland',
  'country.PT': 'Portugal',
  'country.RO': 'Romania',
  'country.RU': 'Russia',
  'country.SM': 'San Marino',
  'country.RS': 'Serbia',
  'country.SK': 'Slovakia',
  'country.SI': 'Slovenia',
  'country.SJ': 'Svalbard and Jan Mayen',
  'country.UA': 'Ukraine',
  'country.GB': 'United Kingdom',
  'country.VA': 'Vatican City',
  'country.AX': 'Åland Islands',
  'country.US': 'United States',
  'country.AS': 'American Samoa',
  'country.AI': 'Anguilla',
  'country.AG': 'Antigua and Barbuda',
  'country.AR': 'Argentina',
  'country.AW': 'Aruba',
  'country.BS': 'Bahamas',
  'country.BB': 'Barbados',
  'country.BZ': 'Belize',
  'country.BM': 'Bermuda',
  'country.BO': 'Bolivia',
  'country.BR': 'Brazil',
  'country.VG': 'British Virgin Islands',
  'country.CA': 'Canada',
  'country.KY': 'Cayman Islands',
  'country.CL': 'Chile',
  'country.CO': 'Colombia',
  'country.CR': 'Costa Rica',
  'country.CU': 'Cuba',
  'country.CW': 'Curaçao',
  'country.DM': 'Dominica',
  'country.DO': 'Dominican Republic',
  'country.EC': 'Ecuador',
  'country.SV': 'El Salvador',
  'country.FK': 'Falkland Islands',
  'country.GF': 'French Guiana',
  'country.GD': 'Grenada',
  'country.GL': 'Greenland',
  'country.GP': 'Guadeloupe',
  'country.GT': 'Guatemala',
  'country.GY': 'Guyana',
  'country.HT': 'Haiti',
  'country.HN': 'Honduras',
  'country.JM': 'Jamaica',
  'country.MQ': 'Martinique',
  'country.MX': 'Mexico',
  'country.MS': 'Montserrat',
  'country.NI': 'Nicaragua',
  'country.PA': 'Panama',
  'country.PY': 'Paraguay',
  'country.PE': 'Peru',
  'country.PR': 'Puerto Rico',
  'country.BL': 'Saint Barthélemy',
  'country.KN': 'Saint Kitts and Nevis',
  'country.LC': 'Saint Lucia',
  'country.MF': 'Saint Martin',
  'country.PM': 'Saint Pierre and Miquelon',
  'country.VC': 'Saint Vincent and the Grenadines',
  'country.SX': 'Sint Maarten',
  'country.SR': 'Suriname',
  'country.TT': 'Trinidad and Tobago',
  'country.TC': 'Turks and Caicos Islands',
  'country.UY': 'Uruguay',
  'country.VE': 'Venezuela',
  'country.VI': 'U.S. Virgin Islands',
  'country.AF': 'Afghanistan',
  'country.AZ': 'Azerbaijan',
  'country.BH': 'Bahrain',
  'country.BD': 'Bangladesh',
  'country.AE': 'United Arab Emirates',
  'country.BN': 'Brunei',
  'country.BT': 'Bhutan',
  'country.CN': 'China',
  'country.TL': 'East Timor',
  'country.ID': 'Indonesia',
  'country.AM': 'Armenia',
  'country.PH': 'Philippines',
  'country.PS': 'Palestine',
  'country.GE': 'Georgia',
  'country.KR': 'South Korea',
  'country.IN': 'India',
  'country.HK': 'Hong Kong',
  'country.IQ': 'Iraq',
  'country.IR': 'Iran',
  'country.IL': 'Israel',
  'country.JP': 'Japan',
  'country.KH': 'Cambodia',
  'country.QA': 'Qatar',
  'country.KZ': 'Kazakhstan',
  'country.KG': 'Kyrgyzstan',
  'country.CY': 'Cyprus',
  'country.KW': 'Kuwait',
  'country.KP': 'North Korea',
  'country.LA': 'Laos',
  'country.LB': 'Lebanon',
  'country.MO': 'Macau',
  'country.MV': 'Maldives',
  'country.MY': 'Malaysia',
  'country.MM': 'Myanmar',
  'country.MN': 'Mongolia',
  'country.NP': 'Nepal',
  'country.UZ': 'Uzbekistan',
  'country.PK': 'Pakistan',
  'country.SG': 'Singapore',
  'country.LK': 'Sri Lanka',
  'country.SY': 'Syria',
  'country.SA': 'Saudi Arabia',
  'country.TJ': 'Tajikistan',
  'country.TH': 'Thailand',
  'country.TW': 'Taiwan',
  'country.TM': 'Turkmenistan',
  'country.OM': 'Oman',
  'country.JO': 'Jordan',
  'country.VN': 'Vietnam',
  'country.YE': 'Yemen',
  'country.DZ': 'Algeria',
  'country.AO': 'Angola',
  'country.BJ': 'Benin',
  'country.BW': 'Botswana',
  'country.BF': 'Burkina Faso',
  'country.BI': 'Burundi',
  'country.CV': 'Cape Verde',
  'country.CM': 'Cameroon',
  'country.CF': 'Central African Republic',
  'country.TD': 'Chad',
  'country.KM': 'Comoros',
  'country.CG': 'Republic of the Congo',
  'country.CD': 'Democratic Republic of the Congo',
  'country.CI': 'Ivory Coast',
  'country.DJ': 'Djibouti',
  'country.EG': 'Egypt',
  'country.GQ': 'Equatorial Guinea',
  'country.ER': 'Eritrea',
  'country.SZ': 'Eswatini',
  'country.ET': 'Ethiopia',
  'country.GA': 'Gabon',
  'country.GM': 'Gambia',
  'country.GH': 'Ghana',
  'country.GN': 'Guinea',
  'country.GW': 'Guinea-Bissau',
  'country.KE': 'Kenya',
  'country.LS': 'Lesotho',
  'country.LR': 'Liberia',
  'country.LY': 'Libya',
  'country.MG': 'Madagascar',
  'country.MW': 'Malawi',
  'country.ML': 'Mali',
  'country.MR': 'Mauritania',
  'country.MU': 'Mauritius',
  'country.YT': 'Mayotte',
  'country.MA': 'Morocco',
  'country.MZ': 'Mozambique',
  'country.NA': 'Namibia',
  'country.NE': 'Niger',
  'country.NG': 'Nigeria',
  'country.RE': 'Réunion',
  'country.RW': 'Rwanda',
  'country.SH': 'Saint Helena',
  'country.ST': 'São Tomé and Príncipe',
  'country.SN': 'Senegal',
  'country.SC': 'Seychelles',
  'country.SL': 'Sierra Leone',
  'country.SO': 'Somalia',
  'country.ZA': 'South Africa',
  'country.SS': 'South Sudan',
  'country.SD': 'Sudan',
  'country.TZ': 'Tanzania',
  'country.TG': 'Togo',
  'country.TN': 'Tunisia',
  'country.UG': 'Uganda',
  'country.EH': 'Western Sahara',
  'country.ZM': 'Zambia',
  'country.ZW': 'Zimbabwe',
  'country.AU': 'Australia',
  'country.CX': 'Christmas Island',
  'country.CC': 'Cocos Islands',
  'country.CK': 'Cook Islands',
  'country.FJ': 'Fiji',
  'country.PF': 'French Polynesia',
  'country.GU': 'Guam',
  'country.HM': 'Heard and McDonald Islands',
  'country.KI': 'Kiribati',
  'country.MH': 'Marshall Islands',
  'country.FM': 'Micronesia',
  'country.NR': 'Nauru',
  'country.NC': 'New Caledonia',
  'country.NZ': 'New Zealand',
  'country.NU': 'Niue',
  'country.NF': 'Norfolk Island',
  'country.MP': 'Northern Mariana Islands',
  'country.PW': 'Palau',
  'country.PG': 'Papua New Guinea',
  'country.PN': 'Pitcairn Islands',
  'country.WS': 'Samoa',
  'country.SB': 'Solomon Islands',
  'country.TK': 'Tokelau',
  'country.TO': 'Tonga',
  'country.TV': 'Tuvalu',
  'country.VU': 'Vanuatu',
  'country.WF': 'Wallis and Futuna',
  'country.AQ': 'Antarctica',
  'country.BV': 'Bouvet Island',
  'country.IO': 'British Indian Ocean Territory',
  'country.TF': 'French Southern and Antarctic Lands',
  'country.GS': 'South Georgia and the South Sandwich Islands',
  'Ticaret Sicil No': 'Trade Registry No',
}; 